// Evaluates user intents and bridges the Dictionary Harness data into Context Prompts

import { fetchWordOfTheDay, searchSlang, getTrendingFlavor } from '../harness/dictionary-harness';
import { DICTIONARY_PROMPTS } from '../prompts/just-the-dictionary';

export async function buildDictionaryContext(textPrompt: string): Promise<string> {
    const lowerPrompt = textPrompt.toLowerCase();
    
    // 1. Intent Detection
    const isAskingForDefinition = lowerPrompt.includes("what does") || lowerPrompt.includes("define") || lowerPrompt.includes("meaning of");
    const isAskingForWOTD = lowerPrompt.includes("word of the day") || lowerPrompt.includes("wotd");

    // 2. Fetch Live BetterBase Data via Harness and format via Prompts
    if (isAskingForWOTD) {
        const wotd = await fetchWordOfTheDay();
        if (wotd) {
            return DICTIONARY_PROMPTS.WOTD(wotd.word, wotd.definition);
        }
    } else if (isAskingForDefinition) {
        const result = await searchSlang(lowerPrompt);
        if (result) {
            return DICTIONARY_PROMPTS.SEARCH_SUCCESS(result.word, result.definition, result.example || 'None');
        } else {
            return DICTIONARY_PROMPTS.SEARCH_FAILED();
        }
    } else {
        // Just casual chat. Grab flavor words!
        const flavorWords = await getTrendingFlavor();
        if (flavorWords) {
            return DICTIONARY_PROMPTS.FLAVOR(flavorWords);
        }
    }
    
    return "";
}
